import { memo } from 'react';

import * as S from './vehicle-message.styles';

import type { TVehicleMessageConfig } from './vehicle-message.types';
import { useVehicleMessageLogic } from './vehicle-message.hook';
import { VEHICLE_MESSAGE_STRINGS } from './utils/vehicle-message.constants';

const VehicleMessage = memo(({
	title,
	description,
	vehicleType = 'Car',
	photoPath,
	advertiseId,
	advertiseUrl
}: TVehicleMessageConfig) => {
	const { isCar, imgSrc, adUrl } = useVehicleMessageLogic({ vehicleType, photoPath, advertiseId, advertiseUrl });

	if (!advertiseId) return null;

	return (
		<S.VehicleMessage data-qa="vehicle-message-link" href={adUrl} target="_blank" title={VEHICLE_MESSAGE_STRINGS.SEE_AD_TITLE}>
			<S.ImgWrapper isCar={isCar} imgSrc={imgSrc} data-testid="img-wrapper" data-qa="img-wrapper" />
			<S.ContentWrapper>
				<S.Title>{title}</S.Title>
				{description && <S.Description>{description}</S.Description>}
			</S.ContentWrapper>
		</S.VehicleMessage>
	);
});

VehicleMessage.displayName = 'VehicleMessage';
export { VehicleMessage };
